import getChildren from './getChildren';
function walkCallback(node, callback, parent) {
    callback(node, parent);
    getChildren(node).forEach(n => walkCallback(n, callback, node));
}
export function walk(node, callbacks, parent) {
    const callback = typeof callbacks === 'object' ? callbacks.node : callbacks;
    walkCallback(node, callback, parent);
}
export default walk;    //# sourceMappingURL=walk.js.map
